import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '..\\layouts\\error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_axios_692a3a2b from 'nuxt_plugin_axios_692a3a2b' // Source: .\\axios.js (mode: 'all')
import nuxt_plugin_appinsightsserver_ae560590 from 'nuxt_plugin_appinsightsserver_ae560590' // Source: .\\appinsights.server.js (mode: 'server')
import nuxt_plugin_appinsightsclient_431b8bb0 from 'nuxt_plugin_appinsightsclient_431b8bb0' // Source: .\\appinsights.client.js (mode: 'client')
import nuxt_plugin_gtm_30398fc1 from 'nuxt_plugin_gtm_30398fc1' // Source: .\\gtm.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ..\\plugins\\axios.js (mode: 'all')
import nuxt_plugin_autodeclare_38e5c8f5 from 'nuxt_plugin_autodeclare_38e5c8f5' // Source: ..\\plugins\\auto-declare.js (mode: 'all')
import nuxt_plugin_breakpoint_08bc58b0 from 'nuxt_plugin_breakpoint_08bc58b0' // Source: ..\\plugins\\breakpoint.js (mode: 'all')
import nuxt_plugin_directives_521c0486 from 'nuxt_plugin_directives_521c0486' // Source: ..\\plugins\\directives.js (mode: 'all')
import nuxt_plugin_linkresolver_46d24254 from 'nuxt_plugin_linkresolver_46d24254' // Source: ..\\plugins\\link-resolver.js (mode: 'all')
import nuxt_plugin_logger_057b83b1 from 'nuxt_plugin_logger_057b83b1' // Source: ..\\plugins\\logger.js (mode: 'all')
import nuxt_plugin_momentbusinessdays_39f745ac from 'nuxt_plugin_momentbusinessdays_39f745ac' // Source: ..\\plugins\\moment-business-days.js (mode: 'all')
import nuxt_plugin_htmlserializer_61e7c30e from 'nuxt_plugin_htmlserializer_61e7c30e' // Source: ..\\plugins\\html-serializer.js (mode: 'all')
import nuxt_plugin_stringextensions_0883cb58 from 'nuxt_plugin_stringextensions_0883cb58' // Source: ..\\helpers\\string-extensions.js (mode: 'all')
import nuxt_plugin_vuetify_d6afc2c2 from 'nuxt_plugin_vuetify_d6afc2c2' // Source: ..\\plugins\\vuetify.js (mode: 'all')
import nuxt_plugin_prismicvue_b8707cce from 'nuxt_plugin_prismicvue_b8707cce' // Source: ..\\plugins\\prismic-vue.js (mode: 'all')
import nuxt_plugin_vuesocialsharing_216967be from 'nuxt_plugin_vuesocialsharing_216967be' // Source: ..\\plugins\\vue-social-sharing.js (mode: 'all')
import nuxt_plugin_vueagile_6bd42cd0 from 'nuxt_plugin_vueagile_6bd42cd0' // Source: ..\\plugins\\vue-agile.js (mode: 'all')
import nuxt_plugin_msalgtmclient_51102710 from 'nuxt_plugin_msalgtmclient_51102710' // Source: ..\\plugins\\msal-gtm.client.js (mode: 'client')
import nuxt_plugin_giftcardcache_50f0a52a from 'nuxt_plugin_giftcardcache_50f0a52a' // Source: ..\\plugins\\gift-card-cache.js (mode: 'all')
import nuxt_plugin_avalaragencert_7c50d583 from 'nuxt_plugin_avalaragencert_7c50d583' // Source: ..\\plugins\\avalara-gen-cert.js (mode: 'client')
import nuxt_plugin_stripe_64a3c3d4 from 'nuxt_plugin_stripe_64a3c3d4' // Source: ..\\plugins\\stripe.js (mode: 'client')
import nuxt_plugin_sessiondata_b16628c0 from 'nuxt_plugin_sessiondata_b16628c0' // Source: ..\\plugins\\session-data.js (mode: 'client')
import nuxt_plugin_customstyles_b7943c22 from 'nuxt_plugin_customstyles_b7943c22' // Source: ..\\plugins\\custom-styles.js (mode: 'client')
import nuxt_plugin_filters_2dd71012 from 'nuxt_plugin_filters_2dd71012' // Source: ..\\plugins\\filters.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s - Baker Book House","title":"chapter","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Selling new, used, and bargain Christian books, Bibles and products since 1939."},{"name":"msapplication-TileColor","content":"#38668e"},{"name":"theme-color","content":"#ffffff"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon\u002Ffavicon.ico","id":"favicon"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon\u002Ffavicon-16x16.png","id":"favicon-16"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon\u002Ffavicon-32x32.png","id":"favicon-32"},{"rel":"icon","type":"image\u002Fpng","sizes":"192x192","href":"\u002Ffavicon\u002Fandroid-chrome-192x192.png","id":"favicon-192"},{"rel":"icon","type":"image\u002Fpng","sizes":"256x256","href":"\u002Ffavicon\u002Fandroid-chrome-256x256.png","id":"favicon-256"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Ffavicon\u002Fapple-touch-icon.png"},{"rel":"manifest","href":"\u002Ffavicon\u002Fsite.webmanifest"},{"rel":"mask-icon","href":"\u002Ffavicon\u002Fsafari-pinned-tab.svg","color":"#38668e"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fuse.typekit.net\u002Ftxi0psw.css"}],"script":[{"innerHTML":"{ window.prismic = { endpoint: \"https:\u002F\u002Fbaker-book-house.cdn.prismic.io\u002Fapi\u002Fv2\"} }"},{"src":"\u002F\u002Fstatic.cdn.prismic.io\u002Fprismic.min.js"},{"src":"https:\u002F\u002Fjs.stripe.com\u002Fv3\u002F"},{"src":"https:\u002F\u002Fapp.certcapture.com\u002Fgencert2\u002Fjs\u002F"},{"innerHTML":"\n          var ScarabQueue = ScarabQueue || [];\n          (function(id) {\n            if (document.getElementById(id)) return;\n            var js = document.createElement('script'); js.id = id;\n            js.src = '\u002F\u002Fcdn.scarabresearch.com\u002Fjs\u002F1FA628B1267BDE01\u002Fscarab-v2.js';\n            var fs = document.getElementsByTagName('script')[0];\n            fs.parentNode.insertBefore(js, fs);\n          })('scarab-js-api');\n        "},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-T4PG49P')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"__dangerouslyDisableSanitizers":["script"],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-T4PG49P&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_axios_692a3a2b === 'function') {
    await nuxt_plugin_axios_692a3a2b(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_appinsightsserver_ae560590 === 'function') {
    await nuxt_plugin_appinsightsserver_ae560590(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_appinsightsclient_431b8bb0 === 'function') {
    await nuxt_plugin_appinsightsclient_431b8bb0(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_30398fc1 === 'function') {
    await nuxt_plugin_gtm_30398fc1(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_autodeclare_38e5c8f5 === 'function') {
    await nuxt_plugin_autodeclare_38e5c8f5(app.context, inject)
  }

  if (typeof nuxt_plugin_breakpoint_08bc58b0 === 'function') {
    await nuxt_plugin_breakpoint_08bc58b0(app.context, inject)
  }

  if (typeof nuxt_plugin_directives_521c0486 === 'function') {
    await nuxt_plugin_directives_521c0486(app.context, inject)
  }

  if (typeof nuxt_plugin_linkresolver_46d24254 === 'function') {
    await nuxt_plugin_linkresolver_46d24254(app.context, inject)
  }

  if (typeof nuxt_plugin_logger_057b83b1 === 'function') {
    await nuxt_plugin_logger_057b83b1(app.context, inject)
  }

  if (typeof nuxt_plugin_momentbusinessdays_39f745ac === 'function') {
    await nuxt_plugin_momentbusinessdays_39f745ac(app.context, inject)
  }

  if (typeof nuxt_plugin_htmlserializer_61e7c30e === 'function') {
    await nuxt_plugin_htmlserializer_61e7c30e(app.context, inject)
  }

  if (typeof nuxt_plugin_stringextensions_0883cb58 === 'function') {
    await nuxt_plugin_stringextensions_0883cb58(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetify_d6afc2c2 === 'function') {
    await nuxt_plugin_vuetify_d6afc2c2(app.context, inject)
  }

  if (typeof nuxt_plugin_prismicvue_b8707cce === 'function') {
    await nuxt_plugin_prismicvue_b8707cce(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharing_216967be === 'function') {
    await nuxt_plugin_vuesocialsharing_216967be(app.context, inject)
  }

  if (typeof nuxt_plugin_vueagile_6bd42cd0 === 'function') {
    await nuxt_plugin_vueagile_6bd42cd0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_msalgtmclient_51102710 === 'function') {
    await nuxt_plugin_msalgtmclient_51102710(app.context, inject)
  }

  if (typeof nuxt_plugin_giftcardcache_50f0a52a === 'function') {
    await nuxt_plugin_giftcardcache_50f0a52a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_avalaragencert_7c50d583 === 'function') {
    await nuxt_plugin_avalaragencert_7c50d583(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_stripe_64a3c3d4 === 'function') {
    await nuxt_plugin_stripe_64a3c3d4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sessiondata_b16628c0 === 'function') {
    await nuxt_plugin_sessiondata_b16628c0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_customstyles_b7943c22 === 'function') {
    await nuxt_plugin_customstyles_b7943c22(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2dd71012 === 'function') {
    await nuxt_plugin_filters_2dd71012(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
